export default __webpack_public_path__ + "static/media/login-bg.bf8eb115.webp";